import {
    favoriteChannelsEndpoint,
    markFavoriteEndpoint,
    unMarkFavoriteEndpoint,
} from '@/api/apiConstants'
import { getWithAuth, postWithAuth, putWithAuth } from '@/api/httpRequests'
import Channel from '@/shared/classes/channels/channel'

import { getErrorMessage } from '@/shared/lib'
import { FavoriteProductType } from '@/features/favorites/FavoritesRepository'
export const getApiFavorites = async (profileId: string) => {
    try {
        const favoriteChannels = await getWithAuth(
            `${favoriteChannelsEndpoint}/${profileId}`,
            undefined
        )
        return favoriteChannels.channels
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('fetch favorites list failure')
    }
}

export const updateApiFavoritesChannel = async (
    channels: Channel[],
    profileId: string
) => {
    try {
        const requestBody = {
            channels,
        }
        const stringifiedBody = JSON.stringify(requestBody)
        await putWithAuth(
            `${favoriteChannelsEndpoint}/${profileId}`,
            false,
            stringifiedBody
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('update favorites list failure')
    }
}

export const markApiFavoriteItem = async (
    profileId: string,
    productType: FavoriteProductType,
    productId: string
) => {
    try {
        const requestBody = { productId, productType }
        const stringifiedBody = JSON.stringify(requestBody)
        await postWithAuth(
            `${markFavoriteEndpoint}/${profileId}`,
            true,
            stringifiedBody,
            profileId
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('mark channel as favorite failure')
    }
}

export const unMarkApiFavoriteItem = async (
    profileId: string,
    productType: FavoriteProductType,
    productId: string
) => {
    try {
        const requestBody = {
            productType,
            productId,
        }
        const stringifiedBody = JSON.stringify(requestBody)
        await postWithAuth(
            `${unMarkFavoriteEndpoint}/${profileId}`,
            true,
            stringifiedBody
        )
    } catch (error) {
        getErrorMessage('request', error)
        throw new Error('un mark channel as favorite failure')
    }
}
